import { render } from "./MonthAmountOrders.vue?vue&type=template&id=3f5b59f1"
import script from "./MonthAmountOrders.vue?vue&type=script&lang=js"
export * from "./MonthAmountOrders.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ambientaly/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__